export default __webpack_public_path__ + "static/media/gallery-wip-connection-rods_06.895923d4.jpg";